<div class="heading heading_standard heading_centered">Sign in</div>
<div class="form__desc">
  Not yet a member?
  <a routerLink="/auth/sign-up"><strong>Register</strong></a>
</div>

@if (formError) {
  <p class="system-error">
    {{ formError }}
  </p>
}

<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  [appScrollToInvalidFieldOnFormSubmit]
  [scrollElement]="ScrollElements.WINDOW"
>
  <div class="fields">
    <div
      class="fields__item fields__item_full"
      [appIfInvalid]="usernameFC"
      [validationErrors]="{
        required: 'Please, enter login',
      }"
    >
      <input
        [formControl]="usernameFC"
        type="text"
        placeholder=""
        autocomplete="username"
        id="username"
      />
      <label for="username">Login</label>
      <ng-template [appErrorsHost] />
    </div>

    <div
      class="fields__item fields__item_full"
      [validationErrors]="{
        required: 'Please, enter password',
      }"
      [appIfInvalid]="passwordFC"
    >
      <input
        [formControl]="passwordFC"
        type="password"
        placeholder=""
        maxlength="20"
        autocomplete="current-password"
        id="password"
      />
      <label for="password">Password</label>
      <ng-template [appErrorsHost] />
    </div>

    <button
      type="submit"
      class="button button_dark button_standard button_centered"
    >
      Sign in
    </button>
    <app-sign-in-with-google />

    <div class="form__desc">
      <a routerLink="/auth/forgot-password">
        <strong>Forgot password?</strong>
      </a>
    </div>
  </div>
</form>
